// extracted by mini-css-extract-plugin
export default {"accessibilityModeContainer":"S4Xlv","desktop":"LECAB","divider":"al5Y8"};